import { isEmpty } from 'lodash'
import { DateTime } from 'luxon'
import { v4 as uuidv4 } from 'uuid'
import type { UserProfileState } from '@labrav/common'
import { autoSaveThresoldTime } from '../../../common/utils/constants'
import type { LockMetadata } from '../types'

export const shouldAcquireOnboardingLock = (lastActivityAt?: string) => {
  const timeDiff = Math.ceil(
    DateTime.now().diff(
      lastActivityAt ? DateTime.fromISO(lastActivityAt) : DateTime.now(),
      ['seconds']
    ).seconds
  )
  return timeDiff > autoSaveThresoldTime || isEmpty(lastActivityAt)
}

export const buildLockMetadataForCurrentUser = (
  lockMetadata: LockMetadata | undefined,
  user: UserProfileState
): LockMetadata => {
  if (!window.name) {
    window.name = uuidv4()
  }
  return {
    ...lockMetadata,
    windowId: window.name,
    lockedBy: user.userProfile.id,
    lockedByName:
      `${user.userProfile.firstName || ''} ${user.userProfile.lastName || ''}`.trim(),
    lockByEmail: user.userProfile.email,
    lockAcquisitionProbe: true,
  }
}
